import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';

@Component({
  selector: 'app-heading-element',
  templateUrl: './heading-element.component.html',
  styleUrls: ['./heading-element.component.scss']
})
export class HeadingElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  public getLabel(): string {
    return this.element?.label ?? '';
  }
}
